import React, { useState, useEffect } from "react";
import glowBg from "../resources/button_blue_gradient_glow.png";
import glowCircleBg from "../resources/button_blue_gradient_circle_glow.png";
import fadeIcon from "../resources/icon_light_fade_small.png";
import stepIcon from "../resources/icon_light_step_small.png";
import partyIcon from "../resources/icon_light_party_small.png";

const ControlLightAnimate = ({
  onModeChange,
  onSpeedChange,
  onBrightnessChange,
  selectedMode,
  selectedSpeed,
  selectedBrightness,
}) => {
  const [animateMode, setAnimateMode] = useState("");
  const [speedMode, setSpeedMode] = useState("");
  const [brightnessMode, setBrightnessMode] = useState("");

  console.log("Mode: " + selectedMode);   
  console.log("Speed: " + selectedSpeed);   
  console.log("Brightness: " + selectedBrightness);

  useEffect(() => {
    if (selectedMode) setAnimateMode(selectedMode);
  }, [selectedMode]);

  useEffect(() => {
    if (selectedSpeed)
      setSpeedMode(`speed-${selectedSpeed}`);
  }, [selectedSpeed]);

  useEffect(() => {
    if (selectedBrightness)
      setBrightnessMode(`brightness-${selectedBrightness}`);
  }, [selectedBrightness]);

  const handleAnimateClick = (animate) => {
    setAnimateMode(animate);
    onModeChange?.(animate);
  };

  const handleSpeedClick = (n) => {
    setSpeedMode(`speed-${n}`);
    onSpeedChange?.(n);
  };

  const handleBrightnessClick = (n) => {
    setBrightnessMode(`brightness-${n}`);
    onBrightnessChange?.(n);
  };

  return (
    <div
      style={{
        width: "100%",
        borderRadius: "16px",
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        animation: "fadeIn 0.2s ease-out",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        {[
          { key: "fade", label: "Fade", icon: fadeIcon },
          { key: "step", label: "Step", icon: stepIcon },
          { key: "party", label: "Party", icon: partyIcon },
        ].map(({ key, label, icon }) => (
          <div
            key={key}
            onClick={() => handleAnimateClick(key)}
            style={{
              position: "relative",
              width: "70%",
              height: "100px",
              margin: "0 auto",
              marginTop: key === "fade" ? "-10px" : "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={glowBg}
              alt="glow"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "130%",
                height: "130%",
                transform: "translate(-50%, -50%)",
                objectFit: "contain",
                pointerEvents: "none",
                zIndex: 0,
                opacity: animateMode === key ? 1 : 0,
                transition: "opacity 0.3s",
              }}
            />

            <button
              style={{
                position: "relative",
                width: "34%",
                height: "60px",
                background: "transparent",
                border: animateMode === key ? "none" : "2px solid #2f3338",
                borderRadius: "30px",
                color: "white",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 1,
                transition: "border 0.3s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={icon}
                alt={label}
                style={{
                  position: "absolute",
                  left: "15px",
                  width: "34px",
                  height: "34px",
                }}
              />
              <span>{label}</span>
            </button>
          </div>
        ))}
      </div>

      {/* --- Speed --- */}
      <div style={{ width: "100%", marginTop: "20px" }}>
        <div
          style={{
            color: "white",
            fontSize: "20px",
            marginLeft: "15px",
            marginBottom: "6px",
          }}
        >
          Speed
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 10px 15px 10px",
            gap: "10px",
          }}
        >
          {[1, 2, 3, 4, 5].map((n) => (
            <div
              key={n}
              onClick={() => handleSpeedClick(n)}
              style={{
                position: "relative",
                width: "90px",
                height: "90px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={glowCircleBg}
                alt="glow"
                style={{
                  position: "absolute",
                  width: "90px",
                  height: "90px",
                  objectFit: "contain",
                  opacity: speedMode === `speed-${n}` ? 1 : 0,
                  transition: "opacity 0.3s",
                }}
              />
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                  border:
                    speedMode === `speed-${n}`
                      ? "2px solid transparent"
                      : "2px solid #2f3338",
                  zIndex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: "all 0.2s ease",
                }}
              >
                <span style={{ color: "white", fontSize: "20px" }}>{n}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* --- Brightness --- */}
      <div style={{ width: "100%", marginTop: "10px" }}>
        <div
          style={{
            color: "white",
            fontSize: "20px",
            marginLeft: "15px",
            marginBottom: "6px",
          }}
        >
          Brightness
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row", 
            justifyContent: "center",
            alignItems: "center",
            margin: "0 10px 20px 10px",
            gap: "10px",
          }}
        >
          {[1, 2, 3, 4, 5].map((n) => (
            <div
              key={n}
              onClick={() => handleBrightnessClick(n)}
              style={{
                position: "relative",
                width: "90px",
                height: "90px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={glowCircleBg}
                alt="glow"
                style={{
                  position: "absolute",
                  width: "90px",
                  height: "90px",
                  objectFit: "contain",
                  opacity: brightnessMode === `brightness-${n}` ? 1 : 0,
                  transition: "opacity 0.3s",
                }}
              />
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "transparent",
                  border:
                    brightnessMode === `brightness-${n}`
                      ? "2px solid transparent"
                      : "2px solid #2f3338",
                  zIndex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  transition: "all 0.2s ease",
                }}
              >
                <span style={{ color: "white", fontSize: "20px" }}>{n}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
};

export default ControlLightAnimate;
